import axios from "axios";
import React, { useEffect, useState } from "react";
import semangat from "../img/semangat.jpg";

const LandingPage = () => {
  const [data, setData] = useState(null);
  //indikator
  const [fetchStatus, setFetchStatus] = useState(true);

  useEffect(() => {
    if (fetchStatus === true) {
      axios
        .get("https://dev-example.sanbercloud.com/api/job-vacancy")
        .then((res) => {
          let data = res.data.data;
          console.log(data);
          setData([...data]);
        })
        .catch((err) => {
          console.log(err);
        });
      setFetchStatus(false);
    }
  }, [fetchStatus]);
  return (
    <React.Fragment>
      <div className="flex flex-wrap w-full bg-slate-500 rounded-tl-xl overflow-hidden">
        <div className="border-2 border-solid border-cyan-500 flex-auto w-2/3 ">
          <div className="rounded-md w-full mt-12 sm:mb-4 border-2 border-solid border-white">
            <h1 className="md:text-3xl sm:text-xl font-bold text-white text-center">
              YPU <br />
              YANG PENTING USAHA
            </h1>
            <h2 className="pt-16 md:text-2xl sm:text-lg font-bold text-white text-center capitalize">
              Walaupun belum dapet kerja <br /> setidaknya kita sudah usaha
            </h2>
            <h3 className="pt-16 md:text-xl sm:text-sm font-bold text-white text-center capitalize">
              YUK SEMANGAT YUK
            </h3>
          </div>
        </div>
        <div className="flex-auto w-1/3">
          <img className="h-full object-center" src={semangat} alt="semangat" />
        </div>
      </div>
      <div className="bg-cyan-500 w-full">
        <section className="overflow-hidden pb-10">
          <div className="my-10 w-1/2 mx-auto border-white rounded-md border-solid border-2">
            <h1 className="text-white text-center text-xl uppercase">
              Testimoni user kami yang mendapatkan kerja
            </h1>
          </div>
          <div className="container px-5 mx-auto py-3 lg:px-32">
            <div className="flex flex-wrap -m-1 md:-m-2">
              {data !== null &&
                data.map((res) => {
                  return (
                    <div
                      key={res.id}
                      className="flex flex-wrap md:w-1/3 sm:w-1/2 2xl:w-1/4"
                    >
                      <div className="block px-6 py-9 mx-2 my-2 max-w-sm bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                        <p className="mb-2 font-normal text-gray-700 dark:text-gray-400 ">
                          Terima kasih YPU atas jasanya telah membantu saya
                          mendapatkan pekerjaan
                        </p>
                        <h5 className=" text-lg font-bold tracking-tight  text-gray-900 dark:text-white">
                          {res.title} - {res.company_name}
                        </h5>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default LandingPage;
